<template>
    <div class="container-fluid home-page" v-if="!loading">
        <div class="row" v-if="!$store.state.reseller">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h1>Welcome to the Sign Up Portal</h1>
                        <p>This system will allow you to sign up for a Switch Telecom solution in a few easy steps. Once the verification and vetting process has been completed an electronic contract will be generated which you’ll be required to sign. Once we receive the signed contract your solution will be activated.</p>
                        <p>If at any point you have any questions, you are welcome to contact us Toll Free on <a href="tel:0800 060 100" class="d-inline-block">0800 060 100</a> or email <a href="mailto:chat@switchtel.co.za" class="d-inline-block">chat@switchtel.co.za.</a></p>

                        <button class="btn btn-dark w-100" @click="loadSteps">Let's start</button>
                    </div>
                </div>
                
            </div>
            <!-- End of col-md-4 -->
        </div>
        <!-- End of row -->
        <div class="row" v-if="$store.state.reseller">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <img v-if="this.$store.state.resellerLogo" :src="this.$store.state.resellerLogo" class="img-fluid reseller-logo" />
                        <h1>Welcome to the Sign Up Portal</h1>
                        <p class="text-center">{{$store.state.reseller}} is an authorised Switch Telecom Reseller.</p>
                        <p>This portal will allow you to easily sign up for a Switch Telecom Solution in a few easy steps. Once the verification and vetting
                            process has been completed an electronic contract will be generated which you’ll be required to sign.</p>
                        <p>Together with our Authorised Reseller we will ensure that your solution is provisioned in a fast and non-disruptive manner.</p>

                        <button class="btn btn-dark w-100" @click="loadSteps">Let's start</button>
                    </div>
                </div>
                
            </div>
            <!-- End of col-md-4 -->
        </div>
        <!-- End of row -->
    </div>
</template>

<script>

import store from  "@/store/index"; //vuex store

export default {
    name: "Welcome",
  
    mounted() {
        this.loading        = true;
        this.referring_domain = document.referrer;

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let pathReferrer = params.referrer;
        if(pathReferrer == "unlimitedvoip.co.za") {
            this.referring_domain = "unlimitedvoip.co.za";
        }

        //Attempt to load tracking cookie
        let trackingCookie = document.cookie.match('(^|;) ?swt_wp_marketing=([^;]*)(;|$)');
        if(trackingCookie) {
            this.tracking_cookie = trackingCookie[2];
        }

        if(this.$route.query.rsl){
            this.reseller_id = this.$route.query.rsl;
        }
        if(this.$route.query.qid){
            this.quote_id = this.$route.query.qid;
        }
        if(this.$route.query.tos){
            this.transfer_of_service = this.$route.query.tos;
        }

        //When there is no reseller param, we will show the generic welcome page for the online signup
        if(!this.reseller_id){
            this.loading = false;
        }

        //We will make a call to the API to fetch content related to the reseller
        //And we will show a custom welcome page for reseller, and set reseller related options
        if(this.reseller_id){
            this.fetchContent();        
        }
    },
    data() {
        return {
            reseller_id : null,
            quote_id: null,
            loading: false,
            referring_domain: null,
            transfer_of_service: null,
            tracking_cookie: null,
        }
           
    }, //end of data

    methods: {
        /**
         * We will load the params if existing, and move to the signup page
         * @return void
         */
        loadSteps: function(){
            var queryParams = {};
            if(this.reseller_id){
                queryParams.rsl = this.reseller_id;
            }
            if(this.quote_id){
                queryParams.qid = this.quote_id;
            }
            if(this.transfer_of_service){
                queryParams.tos = this.transfer_of_service;
            }
            if(this.referring_domain && this.referring_domain == "unlimitedvoip.co.za"){
                queryParams.referrer = this.referring_domain;
            }

            this.$router.push({name: 'signup', query: queryParams});
        },

        /**
         * We make a call to the API to fetch content 
         * @return void
         */
        fetchContent: function(){
            var url = "/online-signup-service-api/v1/signup/token";
            this.$http.post(url, { page: 1 }).then(result => {
                var data = result.data;

                if (data.success) {
                    store.commit('setToken', data.data.token);

                    if(store.state.token != "")
                    {
                        url = "/online-signup-service-api/v1/signup/welcome_page";
                        var dataToPost = {
                            page: 1,
                            token: store.state.token,
                            reseller_id: this.reseller_id,
                            referring_domain: this.referring_domain,
                            tracking_cookie: this.tracking_cookie,
                        }
                        this.$http.post(url, dataToPost).then(result => {
                            var data = result.data;

                            if(data.data.show_invalid === true){
                                this.$router.push('invalid');

                                return;
                            }

                            //store functions to set reseller and resellerLogo
                            store.commit('setResellerOptions', data.data);

                            this.loading = false;
                        });
                    }
                
                }
            });
        }, //end of fetchContent
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.home-page{
    position: relative;
    display: flex;
    min-height: calc(100vh - 132px);
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: url(../assets/images/signup-bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
}
.home-page::before{
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    background: url(../assets/images/signup-page-blocks.png);
    background-color: rgba(51, 65, 74, 0.88);
}
.home-page .row{
    position: relative;
}
.home-page .card{
    max-width: 400px;
    padding: 30px;
    border-radius: 10px;
}
.home-page h1{
    position: relative;
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 25px;
}

.home-page p{
    font-size: 1rem;
    text-align: justify;
}
.reseller-logo{
    width: 150px;
    margin-bottom: 20px;
}

@media only screen and (max-width: 768px) {
    .not-found-page{
        min-height: calc(100vh - 72px);
    }
    .home-page h1{
        font-size: 1.6rem;
    }
    .home-page p{
        font-size: 1rem;
    }
}
</style>
